import { useEffect } from 'react'
import { FieldValues, UseFormReset } from 'libs/form'
import { Me } from 'shared/types/general.types'

type UsePopulateProfileProps = {
	data: Me
	reset: UseFormReset<FieldValues>
}

export const getProfileFormValues = (data: Me) => ({
	name: data.name,
	email: data.email,
	phone_number: data.phone_number,
	ssn: data.ssn,
	bank_account: data.bank_account,
	bizum_phone: data.bizum_phone,
	payout_method: data.payout_method,
	address: data.address
})

export const usePopulateProfile = ({ data, reset }: UsePopulateProfileProps) => {
	useEffect(() => {
		if (data) {
			reset(getProfileFormValues(data))
		}
	}, [data, reset])
}
